import { FontAwesomeIcon } from "@fortawesome/react-native-fontawesome";
import type { AnimatableNumericValue } from "react-native";

import { useColorToken } from "@/hooks/useColorToken";
import type { FAIconName } from "@/ui/core/Icon/IconDefinitions";
import { IconDefinitions } from "@/ui/core/Icon/IconDefinitions";
import Box from "@/ui/layout/Box";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

type IconSize = "lg" | "md" | "sm" | "xs";

const IconSizeMap: Record<IconSize, number> = {
  lg: 20,
  md: 15,
  sm: 12,
  xs: 10,
};

const IconContainerSizeMap: Record<IconSize, number> = {
  lg: 22,
  md: 20,
  sm: 16,
  xs: 12,
};

interface IconProps extends BaseViewProps {
  color?: string;
  name: FAIconName;
  opacity?: AnimatableNumericValue;
  size?: IconSize;
}

const Icon = ({
  accessibilityLabel,
  color = ColorToken.NeutralPrimary,
  name,
  opacity,
  size = "md",
  testID,
}: IconProps) => {
  const iconDefinition = IconDefinitions[name];
  const iconSize = IconSizeMap[size];

  // Using same color as fallback to allow any color to be passed
  const iconColor = useColorToken({ colorKey: color, fallback: color });

  return (
    <Box
      accessibilityLabel={accessibilityLabel}
      style={{
        alignItems: "center",
        height: IconContainerSizeMap[size],
        justifyContent: "center",
        opacity,
        width: IconContainerSizeMap[size],
      }}
      testID={joinTestIDs(testID, "icon")}
    >
      <FontAwesomeIcon
        color={iconColor}
        icon={iconDefinition}
        size={iconSize}
      />
    </Box>
  );
};

export type { IconProps, IconSize };
export default Icon;
